export default {
  grinning: '😀',
  smiley: '😃',
  smile: '😄',
  grin: '😁',
  blush: '😊',
  slightly_smiling_face: '🙂',
  sunglasses: '😎',
  partying_face: '🥳',
  hugging_face: '🤗',
  'star-struck': '🤩',
  robot_face: '🤖',
  heart_hands: '🫶',
  raised_hands: '🙌',
  clap: '👏',
  pray: '🙏',
  handshake: '🤝',
  thumbs_up: '👍',
  i_love_you_hand_sign: '🤟',
  ok_hand: '👌',
  wave: '👋',
  muscle: '💪',
  eyes: '👀',
  heart: '❤️',
  green_heart: '💚',
  blue_heart: '💙',
  star: '⭐',
  zap: '⚡',
  fire: '🔥',
  boom: '💥',
  birthday: '🎂',
  champagne: '🍾',
  sports_medal: '🏅',
  first_place_medal: '🥇',
  second_place_medal: '🥈',
  third_place_medal: '🥉',
  trophy: '🏆',
  rotating_light: '🚨',
  bulb: '💡',
  hammer_and_wrench: '🛠️',
  confetti_ball: '🎊',
  tada: '🎉',
  chart_with_upwards_trend: '📈',
  clipboard: '📋',
  safety_vest: '🦺',
  '100': '💯',
  warning: '⚠️',
  recycle: '♻️',
  white_check_mark: '✅',
  globe_with_meridians: '🌐',
}
